import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import MainSection from '@/components/MainSection';
import Crm1 from '@/assets/svg/products/Crm1';
import CrmDetailContent from '../components/crm/CrmDetailContent';

const DETAIL_KEY = 'hms';

export default function CrmHms() {
    const { t } = useTranslation();

    const title = t(`crmPage.details.${DETAIL_KEY}.title`);
    const description = t(`crmPage.details.${DETAIL_KEY}.description`);

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
                <link rel="canonical" href={`/crm/${DETAIL_KEY}`} />
            </Helmet>
            <div className="w-full mb-[100px] relative overflow-hidden ">
                <MainSection title={title} description={description} icon={<Crm1 />} />
            </div>

            <CrmDetailContent detailKey={DETAIL_KEY} />
        </>
    );
}
